module.exports = __webpack_public_path__ + "img/box-tissue.b0ec10ef.svg";